module.exports = __webpack_public_path__ + "img/street-food.e9be6d42.svg";